import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick || (() => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  }))} className={`group relative inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-hover text-charcoal font-bold py-4 px-8 rounded-none transition-colors duration-300 shadow-lg ${className}`} data-id="element-49">
      <span className="tracking-wide uppercase text-sm md:text-base" data-id="element-50">
        {children}
      </span>
      <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-51" />
    </motion.button>;
}